import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your translation files
import enTranslation from './en/translation.json';
import deTranslation from './de/translation.json';

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    fallbackLng: 'en', // Default language
    debug: true, // Enable debug mode in development
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    resources: {
      en: {
        translation: enTranslation, // Load English translations
      },
      de: {
        translation: deTranslation, // Load German translations
      },
    },
    detection: {
      // Configure language detection
      order: ['localStorage', 'navigator', 'htmlTag'], // Check localStorage first
      caches: ['localStorage'], // Cache the selected language in localStorage
    },
  });

export const handleLanguageChange = (langCode: string) => {
  i18n.changeLanguage(langCode);
};

export default i18n;